import { generatePath, useParams } from 'react-router-dom';
import ModalDialog, {
  ModalCloseHandler,
  ModalCloseReason,
} from 'src/components/ModalDialog';
import { pepApiRequest, RequestMethod, useStatefulApi } from 'src/services';
import { useAlert, AlertType } from 'src/components/AlertsProvider';
import { useForm } from 'src/components/Form';
import { useStoreUnitActions } from 'src/redux/helpers';
import { solutionGroupsFormFields } from '../formFields';
import { SolutionGroupItem } from '../../types';
import { API_SOLUTION_GROUP_PUT } from '../../constants';
import solutionsStore from '../../redux';

type Props = {
  item: SolutionGroupItem;
  open: boolean;
  onClose: ModalCloseHandler;
};

const containerStyle = {
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
};

function SolutionGroupsEditModal({ item, open, onClose }: Props) {
  const { showAlert } = useAlert();
  const { solutionId } = useParams();
  const [onSubmit, loading] = useStatefulApi(
    (params) =>
      pepApiRequest({
        method: RequestMethod.Put,
        url: generatePath(API_SOLUTION_GROUP_PUT, {
          solutionId,
          groupId: item.id,
        }),
        params,
      }),
    () => {
      showAlert({
        type: AlertType.Info,
        title: 'Solutions group modified',
        text: `${item?.name || ''} group has been updated successfully.`,
      });
      onClose(null, ModalCloseReason.completeAction);
    }
  );

  const [form, handleSubmit] = useForm({
    fields: solutionGroupsFormFields(),
    values: item,
    sx: containerStyle,
    onSubmit,
  });

  return (
    <ModalDialog
      open={open}
      title={`Edit Group: ${item?.name}`}
      loading={loading}
      onClose={onClose}
      onConfirm={handleSubmit}
      confirmBtnText="Save"
      maxWidth="sm"
    >
      {form}
    </ModalDialog>
  );
}

export default SolutionGroupsEditModal;
